import React, { useContext, useState, useEffect } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { Context } from '..';
import Calendar from '../components/Calendar';
import { Spinner, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { fetchApplicationForms } from '../http/resourcesServicesAPI';
import { APPLICATION_FORMS_ROUTE } from '../utils/consts';

const DecisionProcess = () => {
    const { resourcesServices } = useContext(Context);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchApplicationForms()
            .then((data) => {
                resourcesServices.setApplicationForms(data);
            })
            .finally(() => setLoading(false));
    }, []);
    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center py-5">
                <Spinner animation={'grow'} />
            </div>
        );
    }
    return (
        <div className="d-flex flex-md-row flex-column justify-content-around px-4 border-bottom">
            <div className="d-flex flex-column px-5 py-4 col-md-8">
                <div className="block-title pb-4">
                    <span>Modele de cereri</span>
                </div>
                <Tabs
                    defaultActiveKey="application_forms"
                    id="uncontrolled-tab-example"
                    className="mb-3 text-primary fw-bold"
                >
                    <Tab eventKey="application_forms" title="Formulare Cereri">
                        <Accordion className="pb-4 w-100">
                            {resourcesServices.applicationForms.count > 0
                                ? resourcesServices.applicationForms.rows.map((item, idx) =>
                                      item.application_forms_files.length > 0 ? (
                                          <Accordion.Item
                                              eventKey={'aform-' + idx}
                                              key={'aform-' + idx}
                                              className="border-0"
                                          >
                                              <Accordion.Header>
                                                  <Link
                                                      className="fw-bold d-flex ps-xl-1 font-2 text-primary text-justify align-items-center pe-4 text-decoration-none"
                                                      to={APPLICATION_FORMS_ROUTE + '/' + item.id}
                                                  >
                                                      {item.title}
                                                  </Link>
                                              </Accordion.Header>
                                              <div className="d-flex justify-content-start py-1 ps-4">
                                                  <span className="border rounded border-primary px-2 text-primary">
                                                      {item.date}
                                                  </span>
                                              </div>
                                              <Accordion.Body>
                                                  {item.application_forms_files.map((sub_item, sub_idx) => (
                                                      <Link
                                                          to={process.env.REACT_APP_API_URL + sub_item.doc}
                                                          key={sub_idx}
                                                          className="text-primary text-decoration-none"
                                                      >
                                                          <div className="d-flex align-items-center">
                                                              <i
                                                                  className={`bi bi-filetype-${sub_item.doc_type} icon-2 text-primary rounded ms-4 px-2 text-primary`}
                                                              />
                                                              <span
                                                                  className="text-wrap"
                                                                  style={{ textAlign: 'justify' }}
                                                              >
                                                                  {sub_item.doc.substring(
                                                                      0,
                                                                      sub_item.doc.lastIndexOf('.')
                                                                  )}
                                                              </span>
                                                          </div>
                                                      </Link>
                                                  ))}
                                              </Accordion.Body>
                                          </Accordion.Item>
                                      ) : (
                                          <div className="d-flex flex-column mb-4 ps-4 ps-xl-0">
                                              <Link
                                                  className="fw-bold font-2 ps-xl-4 text-primary text-justify pe-4 text-decoration-none"
                                                  to={APPLICATION_FORMS_ROUTE + '/' + item.id}
                                              >
                                                  {item.title}
                                              </Link>
                                              <div className="d-flex justify-content-start py-2 ps-xl-4 pt-3">
                                                  <span className="border rounded border-primary px-2 text-primary">
                                                      {item.date}
                                                  </span>
                                              </div>
                                          </div>
                                      )
                                  )
                                : null}
                        </Accordion>
                    </Tab>
                </Tabs>
            </div>
            <Calendar />
        </div>
    );
};

export default DecisionProcess;
